var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.97,
    height: 66.97,
    viewBox: "0 0 66.97 66.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M33.485,0A33.485,33.485,0,1,0,66.97,33.484,33.486,33.486,0,0,0,33.485,0ZM38.6,51.767a5.1,5.1,0,0,1-10.208,0V29.527a5.1,5.1,0,0,1,10.208,0ZM33.485,20.245a5.607,5.607,0,1,1,5.608-5.607A5.608,5.608,0,0,1,33.485,20.245Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.eb249294c5c2e6ada85af13e2f44ee7e.svg";
export { ForwardRef as ReactComponent };